var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-personiblankett';
                    var viewUrl = 'gfx/sprite.svg#view-icon-personiblankett';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 75 75',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };